/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type FloodAreaEnum = 1 | 2 | 3 | 4;

export const FloodAreaEnum = {
    NUMBER_1: 1 as FloodAreaEnum,
    NUMBER_2: 2 as FloodAreaEnum,
    NUMBER_3: 3 as FloodAreaEnum,
    NUMBER_4: 4 as FloodAreaEnum
};

